// routes.js
const routes = {
  home: '/',
  shop: '/shop',
  blogs: '/blogs',
  aboutUs: '/aboutus',
  contactUs: '/contact',
  viewDress: '/view',
};

export default routes;
